module.exports = __webpack_public_path__ + "assets/mui.82291019.svg";